import { GROOMING_SEARCH_URL } from '../constants';

/**
 * Everything that can be serialized into query params when linking to the grooming
 * search page URL.
 *
 * Note the camel-cased `locationType`, which is what the grooming search page reads,
 * unlike the snake-cased `location_type` the core and training search pages read.
 */
export type GroomingSearchPageParams = {
  location?: string | null;
  centerlat?: number | string | null;
  centerlng?: number | string | null;
  locationType?: string | null;
};

const setParam = (
  searchParams: URLSearchParams,
  key: string,
  value: number | string | null | undefined
): void => {
  if (value === null || value === undefined || value === '') return;
  searchParams.set(key, String(value));
};

export const encodeGroomingSearchPageParams = (
  params: GroomingSearchPageParams
): URLSearchParams => {
  const searchParams = new URLSearchParams();

  setParam(searchParams, 'location', params.location);
  setParam(searchParams, 'centerlat', params.centerlat);
  setParam(searchParams, 'centerlng', params.centerlng);
  setParam(searchParams, 'locationType', params.locationType);

  return searchParams;
};

/**
 * Builds the URL for navigating to the grooming search page from any other page,
 * optionally seeding it with location filters. Returns the bare page URL when no
 * params apply.
 */
export const getGroomingSearchPageUrl = (params: GroomingSearchPageParams = {}): string => {
  const queryString = encodeGroomingSearchPageParams(params).toString();
  return queryString ? `${GROOMING_SEARCH_URL}?${queryString}` : GROOMING_SEARCH_URL;
};
